import React from 'react'
import {Link} from 'react-router-dom'
import {ICar} from '../../../../models/Car'
import NoImage from '../../../assets/imgs/no-image.png'
import defaultProfile from '../../../assets/imgs/profile-default.png'
import {getCarUrl, localizeCar} from '../../../helpers/car'
import {getGlobalEnv} from '../../../helpers/coreUtil'
import {getFullName} from '../../../helpers/util'
import LocaleText from '../../common/LocaleText'
import ResponsiveImg, {getResponsiveSrcSetsFromWH} from '../../common/ResponsiveImg'
import TopStarThumbnail from '../../common/TopStarThumbnail'
import {useLocale} from '../../hocs/hooks'
import styles from './ReviewItem.scss'

export interface IHomeReview {
  _id: string
  car: ICar
  user: {_id: string, picture: string, first: string, last: string}
  userReviewContent: string
  reviewPhotos?: Array<{url: string, _id: string}>
  userReviewStars: number
}

const thumbnailWidth = 240 //px
const ReviewItem = ({review}: {
  review: IHomeReview
}) => {
  const locale = useLocale()
  const {
    car,
    user,
    userReviewContent,
    reviewPhotos,
    userReviewStars
  } = review
  const {
    photos: [{url = NoImage, caption = 'Car Photo'} = {}],
    name,
  } = localizeCar(locale, car)
  const reviewUrl = reviewPhotos?.[0]?.url || url
  const {
    picture: userIcon = defaultProfile,
  } = user
  const carUrl = getCarUrl(locale, car, true, false, false) + '#reviews'
  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcSet = getResponsiveSrcSetsFromWH(reviewUrl, 200, undefined, { webp: true, cdn })

  return <div className={[styles.container, 'd-flex flex-column flex-md-row position-relative']
    .filter(Boolean).join(' ')}>
    <div className={['overflow-hidden', styles.image].filter(Boolean).join(' ')}>
      <Link to={carUrl} className={[styles.imgWrapper, 'd-flex'].join(' ')}>
        <ResponsiveImg
          caption={caption}
          url={reviewUrl}
          noLazy={false}
          srcSet={srcSet}
          width={thumbnailWidth}
          height={160}
          className={['d-none d-md-inline', styles.photo].join(' ')}
        />
        <ResponsiveImg
          caption={caption}
          url={reviewUrl}
          noLazy={false}
          srcSet={srcSet}
          height={222}
          className={['d-inline d-md-none w-100', styles.photo].join(' ')}
        />
      </Link>
    </div>
    <div className={['text-left d-flex flex-column', styles.info].join(' ')}>
      <Link to={carUrl}
            className={
              ['d-block font-weight-bold text-dark text-carstay-black', styles.title]
                .filter(Boolean).join(' ')
            }>
        <div className="d-inline-block">
          <div className={['ellipsis d-inline-block', styles.titleText].join(' ')}>{name}</div>
          <div className={['d-inline-block', styles.titleWith].join(' ')}><LocaleText ja="のレビュー" en=" review"/></div>
        </div>
      </Link>
      <Link to={carUrl} className={['text-carstay-black', styles.content].filter(Boolean).join(' ')}>
        <div className={['font-size-12 pre-wrap', styles.userContent, styles.lineClamp].join(' ')}>
          {userReviewContent}
        </div>
      </Link>
      <div className="d-flex justify-content-between align-items-center mt-auto mb-1">
        <div className={['small ellipsis font-weight-bold d-flex align-items-center', styles.name].join(' ')}>
          <ResponsiveImg
            width={50}
            height={50}
            className={[styles.profilePhoto, 'rounded-circle'].join(' ')}
            url={userIcon}
            caption="User image"/>
          <span className="ml-1">{getFullName(locale, user)}</span>
        </div>
        <TopStarThumbnail stars={userReviewStars} hideTotal className={['d-flex', styles.stars].join(' ')}/>
      </div>
    </div>
  </div>
}
ReviewItem.displayName = 'ReviewItem'
export default ReviewItem
